import Vue from "vue";
import Vueditor from "vueditor";
import config from "./options-default";

import "vueditor/dist/style/vueditor.min.css";

Vue.use(Vueditor, config);
